export const featureFlagsCacheKeys = {
  action: {
    flipper: {
      getByAccountId: () => ['flipper_feature_flags_by_account_id'] as const
    }
  }
}
